import { render, staticRenderFns } from "./LandingInfo.vue?vue&type=template&id=1c32122e&scoped=true"
import script from "./LandingInfo.vue?vue&type=script&lang=js"
export * from "./LandingInfo.vue?vue&type=script&lang=js"
import style0 from "./LandingInfo.vue?vue&type=style&index=0&id=1c32122e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32122e",
  null
  
)

export default component.exports